export enum ExecutionTriggeredType {
  MANUAL='MANUAL',
  SCHEDULED='SCHEDULED',
  API='API'
}
